module.exports = __webpack_public_path__ + "img/Download.7bafb98d.svg";